import { useHasUserInterfaceFlags } from '#app/hooks/useHasUserInterfaceFlags.js';
import { localStorage } from '#app/services/storage.js';
import { useCallback, useMemo, useState } from 'react';

const shouldHideProfileMagicServiceIndicatorKey =
  'CONTRA_LOCAL_HIDE_PROFILE_MAGIC_SERVICE_INDICATOR';

export const useProfileMagicServicesTabIndicator = () => {
  const hasUsedProfileMagic = useHasUserInterfaceFlags(
    'HIDE_FTUE_CONTRA_PROFILE_MAGIC',
  );

  const shouldHideProfileMagicServiceIndicatorValue = localStorage.getItem(
    shouldHideProfileMagicServiceIndicatorKey,
  );

  const [
    shouldHideProfileMagicServiceIndicator,
    setShouldHideProfileMagicServiceIndicator,
  ] = useState(shouldHideProfileMagicServiceIndicatorValue === 'true');

  const showProfileMagicServiceIndicator = useCallback(() => {
    localStorage.removeItem(shouldHideProfileMagicServiceIndicatorKey);
    setShouldHideProfileMagicServiceIndicator(false);
  }, []);

  const hideProfileMagicServiceIndicator = useCallback(() => {
    localStorage.setItem(shouldHideProfileMagicServiceIndicatorKey, 'true');
    setShouldHideProfileMagicServiceIndicator(true);
  }, []);

  return useMemo(
    () => ({
      hasUsedProfileMagic,
      hideProfileMagicServiceIndicator,
      shouldHideProfileMagicServiceIndicator,
      showProfileMagicServiceIndicator,
    }),
    [
      hasUsedProfileMagic,
      hideProfileMagicServiceIndicator,
      shouldHideProfileMagicServiceIndicator,
      showProfileMagicServiceIndicator,
    ],
  );
};
